import React, { useEffect, useState } from "react";
import { Modal, Input, Select, Button, Form, notification,message } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import PopupUI from "../Elements/PopupUI";
import { CONFIGURATION_CONVERTER } from "../../Common/Constants";
import { useStoreUpdaterWithAPI } from "../../Hooks/UseStoreUpdaterWithApi";
import { useSelector } from "react-redux";
import { APIConstants } from "../../Common/APIConstants";

const ConverterPopupContent = ({
  onClose, 
  isAdd,
  refetchData ,
  form,
  refetch,
  setRefetch
}) => {
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [modules, setModules] = useState([]) 
  
  const handleClear = () => {
    form.resetFields();
  };

  const handleNotification = (msg, type = "success") => {
    notification.open({
      message: msg,
      type: type, 
      placement: 'topRight',  
      duration: 3, 
    });
  };
  

  useEffect(() => {
    if (isAdd) {
      form.resetFields();
    }
  }, [isAdd, form]);




  const handleAddFormSubmit = (values) => {
    console.log(values);
    // handleOk();
    insertGroup(values);
    onClose()
  };

  const getModules = () => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_MODULES}`
    }).then((res) => {
      if(res&&res.length){
        setModules(res)
      }
      console.log("Get Modules :", res);
    })
  }

  useEffect(() => {
    getModules()
  }, [])

 


  const insertGroup = (formValues) => {
    console.log(formValues);
    const body = {
      converterID: formValues.converterID,
      converterName: formValues.converterName,
      converterIP: formValues.converterIP,
      port: formValues.port,
      noofports: formValues.noofports,
      moduleType: formValues.ConverterType.toString()
    }
    console.log(body)
    const url = `${APIConstants.CONFIG_INSERT_CONVERTER}`;
    console.log(url);
  
    makeRequest({
      type: APIConstants.POST,
      url: url,
      body: body,
    }).then((res) => {
      console.log( res);
      if (res && res.message) {
        // handleNotification("Converter successfully saved!", "success");
        handleNotification(res.message,"success");
        setRefetch(!refetch)  
      } 
      // if (res ) {
      //   handleNotification("Converter successfully saved!", "success");
      //   // handleNotification(res.message,"success");
      //   setRefetch(!refetch)  
      // } 
    }).catch((err) => {
      console.error(err);
      handleNotification("An error occurred while saving the converter.", "error");
    });
  };


  const modeselect = useSelector((state) => state.darkMode);
  const { isdarkMode } = modeselect;

  return (


    <Form
      form={form}
      onFinish={handleAddFormSubmit}
      name="add-group-form"
      className="font-bold w-[350px]"
      layout="horizontal"
      initialValues={{}}

      style={{
        maxWidth: 600,
      }}
      labelCol={{
        span: 10,
        offset: 0,
      }}
      labelAlign="left"
    >
      <Form.Item
        label="ConverterID"
        name="converterID"
        rules={[{ required: true, message: "Please enter Converter ID" }]}
      >
        <Input className="group-input" />
      </Form.Item>
      <Form.Item
        label="Convreter Name"
        name="converterName"
        rules={[{ required: true, message: "Please enter Converter name" }]}
      >
        <Input className="group-input" />
      </Form.Item>
      <Form.Item
        label="Converter IP"
        name="converterIP"
        rules={[{ required: true, message: "Please enter converterIP" }]}
      >
        <Input className="group-input" />
      </Form.Item>
      <Form.Item
        label="Port"
        name="port"
        rules={[{ required: true, message: "Please enter Port" }]}
      >
        <Input className="group-input" />
      </Form.Item>
      <Form.Item
        label="No. of Ports"
        name="noofports"
        rules={[{ required: true, message: "Please enter no of Ports" }]}
       
      >
        <Input className="group-input"   type="number"/>
      </Form.Item>
      <Form.Item
        label="Converter Type"
        name="ConverterType"
        rules={[{ required: true, message: "Please select Types" }]}
      >
        <Select
      className={` ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} `}
      dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
      placeholder="Select Types"
    >
     
      {modules.map((item) => (
        <Select.Option mode='multiple' key={item.moduleId} value={item.moduleId}>
          {item.moduleName} 
        </Select.Option>
      ))}
    </Select>
      </Form.Item>



      <Form.Item className="flex justify-end">
        <Button
          htmlType="submit"
          className="blue-btn mr-2"
        >
          Save
        </Button>
        <Button
          className="blue-btn"
          onClick={handleClear}
        >
          Clear
        </Button>
      </Form.Item>
    </Form>


  )
};

const ConverterPopup = ({
  isAdd,
  setIsAdd,
  isUpdate,
  setIsUpdate,
  updateRecord,
  title,
  refetch,
  setRefetch,
  refetchData 
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();

  // console.log(updateRecord);
  useEffect(() => {
    if (location.pathname === `${CONFIGURATION_CONVERTER}/converter-add-popup`) {
      setIsAdd(true);

      form.resetFields();
    } else {
      setIsAdd(false);

    }
  }, [location.pathname, form]);

  const handleClose = () => {
    setIsAdd(false);

    navigate(`${CONFIGURATION_CONVERTER}`);
    form.resetFields();
  };

  return (
    <>

      <PopupUI

        popupContent={
          <ConverterPopupContent
            onClose={handleClose} 
            isAdd={isAdd}
            isUpdate={isUpdate}

            form={form}

            hasModal={true}
            title={title}
            refetchData={refetchData}
            refetch={refetch}
            setRefetch={setRefetch}
          />
        }
        key={updateRecord?.groupID}
        isAdd={isAdd}
        refetchData={refetchData}

        setIsUpdate={setIsUpdate}
        handleClose={handleClose}

        isOpen={isUpdate || isAdd}

        hasModal={true}
        title={title}
      />

    </>
  );
};

export default ConverterPopup;
